import React from "react";
import { useSelector } from 'react-redux';

const BackgroundImage = () =>
{
  const { uiTheme, productUrls } = useSelector((state) => state.activation);
  return (
    <div
      className="background-image-holder"
      style={{ background: uiTheme.bgColour }}
    >
      <img
        className="background-image"
        style={{
          backgroundImage: `url(${productUrls.bgImg})`,
        }}
        alt="background of product"
      ></img>
    </div>
  );
};

export default BackgroundImage;
